import { FEATURE_FLAGS } from '../../../../featureFlags';
import { frontendURL } from '../../../../helper/URLHelper';
import SettingsWrapper from '../SettingsWrapper.vue';
import { ASSIGNMENT_POLICY_UI_ENABLED } from './assignmentPolicyVisibility';

// Componentes carregados sob demanda: enquanto a tela estiver escondida eles
// nem entram no fluxo de navegação.
const AssignmentPolicyIndex = () => import('./Index.vue');
const AgentAssignmentIndex = () =>
  import('./pages/AgentAssignmentIndexPage.vue');
const AgentAssignmentCreate = () =>
  import('./pages/AgentAssignmentCreatePage.vue');
const AgentAssignmentEdit = () => import('./pages/AgentAssignmentEditPage.vue');
const AgentCapacityIndex = () => import('./pages/AgentCapacityIndexPage.vue');
const AgentCapacityCreate = () => import('./pages/AgentCapacityCreatePage.vue');
const AgentCapacityEdit = () => import('./pages/AgentCapacityEditPage.vue');

const BASE_PATH = 'accounts/:accountId/settings/assignment-policy';

const meta = {
  featureFlag: FEATURE_FLAGS.ASSIGNMENT_V2,
  permissions: ['administrator'],
};

const enabledRoutes = () => [
  {
    path: frontendURL(BASE_PATH),
    component: SettingsWrapper,
    children: [
      {
        path: '',
        redirect: to => {
          return { name: 'assignment_policy_index', params: to.params };
        },
      },
      {
        path: 'index',
        name: 'assignment_policy_index',
        component: AssignmentPolicyIndex,
        meta,
      },
      {
        path: 'assignment',
        name: 'agent_assignment_policy_index',
        component: AgentAssignmentIndex,
        meta,
      },
      {
        path: 'assignment/create',
        name: 'agent_assignment_policy_create',
        component: AgentAssignmentCreate,
        meta,
      },
      {
        path: 'assignment/edit/:id',
        name: 'agent_assignment_policy_edit',
        component: AgentAssignmentEdit,
        meta,
      },
      {
        path: 'capacity',
        name: 'agent_capacity_policy_index',
        component: AgentCapacityIndex,
        meta,
      },
      {
        path: 'capacity/create',
        name: 'agent_capacity_policy_create',
        component: AgentCapacityCreate,
        meta,
      },
      {
        path: 'capacity/edit/:id',
        name: 'agent_capacity_policy_edit',
        component: AgentCapacityEdit,
        meta,
      },
    ],
  },
];

// Tela escondida: nenhuma rota nomeada é registrada e qualquer URL antiga
// (favorito, link colado) de settings/assignment-policy volta para o início
// das Configurações.
const hiddenRoutes = () => [
  {
    path: frontendURL(`${BASE_PATH}/:pathMatch(.*)*`),
    redirect: to => ({
      name: 'settings_home',
      params: { accountId: to.params.accountId },
    }),
  },
];

export const buildAssignmentPolicyRoutes = (
  enabled = ASSIGNMENT_POLICY_UI_ENABLED
) => (enabled ? enabledRoutes() : hiddenRoutes());

export default {
  routes: buildAssignmentPolicyRoutes(),
};
